import React from 'react';
import ReactDOM from 'react-dom';
import { withReferer } from 'plugins/contextual-back';
import { columnWidth, renderList } from 'utils/async-list';
import { Column } from 'react-virtualized';
import { renderCaseCustomer } from '../cases/common';
import $ from 'jquery';
import PlanningModal from './modal/PlanningModal';

function renderIsStudy({ cellData }) {
  if (cellData === true) {
    return <div>Etude</div>;
  } else {
    return <div> Intervention </div>;
  }
}

function displayModal(modal) {
  // Appending content to body
  $(document.body).append(modal);

  // Handling approve button
  const $modal = $('#modal-root');

  $modal
    .modal({
      onApprove: element => {},
      autofocus: false,
    })
    .modal('show');
}

const displayPlanningModal = (id, caseId) => {
  const root = document.getElementById('modal-root');
  const workersData = window.__WORKERS__;

  const onClose = () => {
    $(root).modal('hide');
  };

  if (root && workersData) {
    ReactDOM.unmountComponentAtNode(root);

    const modalContent = ReactDOM.render(
      <PlanningModal
        id={id}
        caseId={caseId}
        workers={workersData}
        onClose={onClose}
      />,
      root
    );
    displayModal(modalContent);
  }
};

const renderNotExecutedActions = ({ rowData }) => {
  const id = rowData.id;

  const onReplanClick = evt => {
    evt.preventDefault();
    evt.stopPropagation();

    displayPlanningModal(id, rowData.caseId);
  };

  const renderButton = (
    <div className="ui buttons">
      <a className="ui basic green button" onClick={onReplanClick}>
        <i className="undo icon" />
        Replanifier
      </a>
    </div>
  );

  return renderButton;
};

function renderColumns(width) {
  return [
    <Column
      key="id"
      dataKey="id"
      cellRenderer={renderNotExecutedActions}
      width={columnWidth(width, 2)}
      label="Action"
      disableSort
    />,
    <Column
      key="name"
      dataKey="name"
      cellRenderer={renderCaseCustomer}
      width={columnWidth(width, 4)}
      label="Nom du chantier"
    />,
    <Column
      key="isStudy"
      dataKey="isStudy"
      width={columnWidth(width, 2)}
      label="Etude"
      cellRenderer={renderIsStudy}
    />,
    <Column
      key="planningDate"
      dataKey="planningDate"
      width={columnWidth(width, 4)}
      label="Date"
    />,
    <Column
      key="justification"
      dataKey="justification"
      width={columnWidth(width, 4)}
      label="Motif"
    />,
  ];
}

function render(url, from) {
  const caseUrl = id => {
    const components = id.split('_');

    if (components[0] === 'AAST-CASE') {
      return withReferer(
        `/pco-manager/aast/cases/${components[1]}/study`,
        from
      );
    } else if (components[0] === 'AAST-INTER') {
      return withReferer(
        `/pco-manager/aast/cases/interventions/${components[1]}`,
        from
      );
    }
  };

  const rowClickedUrl = id => caseUrl(id);
  const loadNextUrl = url;

  renderList(rowClickedUrl, loadNextUrl, renderColumns);
}

export default function list(ctx) {
  render(
    '/pco-manager/aast/interventions/notexecuted.json',
    '/pco-manager/aast/interventions/notexecuted'
  );
}



// WEBPACK FOOTER //
// ./src/modules/saas/aast/interventions/list-notexecuted.js